import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import PanelDev from '../panels/dev/PanelDev';

import PanelTicket from '../panels/ticket/PanelTicket';

export default function LayoutTicket() {

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'ticket':
                                return (<PanelTicket onToggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
